import { TypeChecker } from '@attain-apps/type-guards'

import type { Plugin } from './plugin'
import type { Operation } from './types'

/**
 * Selectors for the survey status state of a space lite record.
 */
export class Selectors {
  /** Whether the confirmation dialog of the given operation is open */
  // NOTE: Intentionally not typed here so that type can be inferred
  public readonly isConfirming

  /** Whether the submit of the given operation is in flight */
  // NOTE: Intentionally not typed here so that type can be inferred
  public readonly isSubmitting

  /** Last submit error of the given operation, as a displayable message */
  // NOTE: Intentionally not typed here so that type can be inferred
  public readonly getErrorMessage

  constructor(plugin: Plugin) {
    // NOTE: an operation is only present in the state while it is the one being
    // confirmed, so everything else is derived from its status
    const getStatus = plugin.feature.createSelectorMethod(
      (operation: Operation) =>
        plugin.feature.state.project(state => state[operation]).asSelector,
    )

    this.isConfirming = plugin.feature.createSelectorMethod(
      (operation: Operation) =>
        getStatus(operation).project(status => !!status).asSelector,
    )

    this.isSubmitting = plugin.feature.createSelectorMethod(
      (operation: Operation) =>
        getStatus(operation).project(status => !!status?.isSubmitting)
          .asSelector,
    )

    this.getErrorMessage = plugin.feature.createSelectorMethod(
      (operation: Operation) =>
        getStatus(operation).project(status => {
          const error = status?.error
          return TypeChecker.isString(error) ? error : error?.message
        }).asSelector,
    )
  }
}
